import { Component, OnInit, AfterViewInit } from '@angular/core';
import { IntegrationPayload } from '../Models/IntegrationPayload';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Configuration } from '../../../app.config';
import { IntegrationService } from '../services/integration.service';

@Component({
  selector: 'app-integration-debug',
  templateUrl: './integration-debug.component.html',
  styleUrls: ['./integration-debug.component.less']
})
export class IntegrationDebugComponent implements OnInit {

  config : Configuration = new Configuration();
  payload : IntegrationPayload;
  apiEndpoint : string = this.config.PhenomURL + 'api/Screening';
  constructor(private http : HttpClient, private route : ActivatedRoute, public integration : IntegrationService) 
  {
  }

  ngOnInit() {
    let appId = this.route.snapshot.paramMap.get('applicantId');
    this.integration.fetchPayload(appId).subscribe((data) => {
      this.payload = data;
    });
  }
}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/integration-debug/integration-debug.component.ts